export default "__VITE_ASSET__f5953bd3__"